/**
 * Article FAQ front-end behaviour — the "Expand all" toggle, and nothing else.
 *
 * Every answer is already in the HTML and every `<details>` is native, so keyboard support,
 * screen-reader support and individual open/close come free from the browser. The one thing
 * the platform does not give us is a way to open all of them at once, and that is the
 * Safari/Firefox find-in-page escape hatch this button exists for (`FaqSection.tsx`, R-FAQ1).
 *
 * The label stays honest when the reader toggles items by hand: `toggle` fires on every
 * `<details>`, and the button reads "Collapse all" only while ALL of them are open — the same
 * `onItemToggle` contract as the reference.
 */

function initFaq( section ) {
	const button = section.querySelector( '[data-ac-faq-toggle]' );
	const items = Array.from( section.querySelectorAll( 'details' ) );

	if ( ! button || items.length === 0 ) {
		return;
	}

	const expandLabel = button.dataset.expandLabel ?? button.textContent;
	const collapseLabel = button.dataset.collapseLabel ?? button.textContent;

	const syncLabel = () => {
		const allOpen = items.every( ( item ) => item.open );
		button.textContent = allOpen ? collapseLabel : expandLabel;
	};

	button.addEventListener( 'click', () => {
		const next = ! items.every( ( item ) => item.open );
		items.forEach( ( item ) => {
			item.open = next;
		} );
		syncLabel();
	} );

	items.forEach( ( item ) => item.addEventListener( 'toggle', syncLabel ) );

	syncLabel();
}

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll( '.wp-block-avoid-content-article-faq' )
		.forEach( initFaq );
} );
